module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "login-aside"
  }, [_c('header', [_c('a', {
    staticClass: "link-home",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goHome()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "logo",
      "viewBox": "0 0 115 22"
    }
  })], 1), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": _vm.$onduro.switchLanguage('de')
    }
  }, [_vm._v("DE")]), _vm._v(" | "), _c('router-link', {
    attrs: {
      "to": _vm.$onduro.switchLanguage('nl')
    }
  }, [_vm._v("NL")]), _vm._v(" | "), _c('router-link', {
    attrs: {
      "to": _vm.$onduro.switchLanguage('en')
    }
  }, [_vm._v("EN")])], 1)]), _vm._v(" "), _c('footer', [_c('a', {
    attrs: {
      "href": 'https://www.onduro.com' + _vm.$onduro.route('terms', null, _vm.locale),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('route.terms.name')) + "\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://www.onduro.com' + _vm.$onduro.route('privacy', null, _vm.locale),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('route.privacy.name')) + "\n        ")]), _vm._v(" "), (!_vm.mobile) ? _c('a', {
    attrs: {
      "href": 'https://www.onduro.com' + _vm.$onduro.route('contact', null, _vm.locale)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('route.contact.name')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.mobile) ? _c('a', {
    attrs: {
      "href": "https://www.onduro.com"
    }
  }, [_vm._v("www.onduro.com")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-252fcc4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/LoginAside.vue
// module id = 490
// module chunks = 234